 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"1":"vendors~compounds-article-intro~compounds-modal-button~eevee-author~elements-list~modules-author-pro~9127c733","2":"default~eevee-author~html-sitemap~modules-form","3":"default~html-sitemap","4":"elements-list","5":"html-sitemap","6":"eevee-author","7":"compounds-modal-button","8":"preview","9":"vendors~modules-product-table~modules-rich-text","10":"vendors~preview","11":"carousel","12":"modules-rich-text","13":"image-text","14":"modules-form","15":"vendors~modules-form","16":"button-default","17":"button-link-button-link","19":"collection-footer","20":"collection-grid","21":"collection-image-grid","22":"collection-image-logo","23":"collection-inline","24":"collection-sidebar","25":"collection-tabs","26":"collection-twocol-content","27":"component","28":"compounds-article-intro","29":"compounds-assurance-text","30":"compounds-author","31":"compounds-card-award-nominee","32":"compounds-click-out-form","33":"compounds-cookie-toggle","34":"compounds-countdown","35":"compounds-form-input-email","36":"compounds-form-input-text","37":"compounds-grid-grid-column","38":"compounds-grid-grid-row","39":"compounds-heading","40":"compounds-iframe","41":"compounds-logobar","42":"compounds-privacy-policy","43":"compounds-quote-block","44":"compounds-table","45":"compounds-video","47":"default","48":"elements-cta","49":"elements-embedded-asset","50":"elements-icon-tile","51":"elements-testimonial-card","52":"elements-text-with-forced-tag","53":"elements-widget-html","54":"featured-posts","55":"fixed-size-grid","56":"full-width","57":"list-item","58":"modules-assurance-bar","59":"modules-author-profile","60":"modules-category-guides-module","61":"modules-collection","62":"modules-featured-cards","63":"modules-figure-module","64":"modules-hero","65":"modules-image-callout-module","66":"modules-lead-capture-form","67":"modules-navbar","68":"modules-product-table","69":"modules-read-more-module","70":"modules-reviews","71":"modules-sponsored-by","72":"modules-sub-navigation","73":"simple-category-guide-card","74":"sub-navigation-collection","75":"trustpilot","76":"trustpilot-horizontal","77":"trustpilot-micro","78":"vendors~compounds-article-intro","79":"vendors~compounds-iframe","80":"vendors~compounds-table","81":"vendors~default","82":"vendors~modules-author-profile","83":"vendors~modules-product-table"}[chunkId]||chunkId) + "." + {"1":"ad6d33f9","2":"32145240","3":"ee6458e2","4":"15752ca3","5":"defb2fb2","6":"c5b88e99","7":"3a95358e","8":"88bebf54","9":"4d939709","10":"f4addd60","11":"f6eafce7","12":"b2bf1975","13":"44135eb6","14":"e3ba5b44","15":"2ff32e43","16":"3d075e4d","17":"ed8e4d98","19":"6bb56f82","20":"2cf1839d","21":"7ad75c07","22":"f8ebf22b","23":"4520961c","24":"a65c4df8","25":"91fdec77","26":"1668d7d0","27":"3f3e3eb4","28":"90dc5d1c","29":"1dc043ae","30":"4c4be312","31":"56506544","32":"b3cc9b12","33":"395d450c","34":"babb9335","35":"ede65797","36":"05030a03","37":"bcc579c7","38":"0eea9e9d","39":"2c01c96f","40":"533cd5eb","41":"49607e89","42":"f0ccbb8a","43":"e35ae081","44":"5ddcb898","45":"fe298467","47":"53bbc8f7","48":"b1a62f4c","49":"c41fbdd1","50":"d490e6f1","51":"2d1b35d4","52":"23328769","53":"d4f4c8c0","54":"888e8bf7","55":"ae5ab48f","56":"03622c61","57":"a27b864c","58":"bed64142","59":"108a965c","60":"b1da83ef","61":"b651bb60","62":"1d2d20d6","63":"3931fcd4","64":"f3229819","65":"80251787","66":"a01e614b","67":"a8451412","68":"140ac83e","69":"f3384186","70":"e4541f5f","71":"842c8982","72":"59202d30","73":"414a006f","74":"ab3b435b","75":"8bd8cd92","76":"5490f91a","77":"27a55c68","78":"9602ae11","79":"02b42e0d","80":"67cd0a19","81":"463f4326","82":"a69d8244","83":"a5aa7937","84":"57604ff2"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.uswitch.com/s3/uswitch-assets-eu/recharge-eevee/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["ftlp",0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
